// extracted by mini-css-extract-plugin
export default {"testimonial":"onboarding-testimonial_testimonial__b+Jg1","content":"onboarding-testimonial_content__8EoYP","name":"onboarding-testimonial_name__3hm6F"};